import NavBar from "../elements/navBar";
import "../shopElements/shop.css";
function Head(props) {
  return (
    <div>
      <div className="backnavbar">
        <NavBar type={props.type} />
      </div>
      <h2 className="  help ">
        <div className="helptext">&nbsp;&nbsp;Call  📞+216 25 801 660   &nbsp;&nbsp;&nbsp;  | &nbsp;&nbsp;&nbsp; Send an email 📧  to contact@makerskills.tn 👌</div>
      </h2>
      <div className="shopLogos">
        <img src={`${process.env.REACT_APP_FRONTEND_URL}images/arduinoLogo.png`} alt="arduino" className="logo" />
        <img src= {`${process.env.REACT_APP_FRONTEND_URL}images/seeedLogo.jpeg`}  alt="seeed" className="logoseeed" />
        <img src= {`${process.env.REACT_APP_FRONTEND_URL}images/raspberryPiLogo.png`}  alt="raspberry Pi" className="logoraspberry" />
        <img src=  {`${process.env.REACT_APP_FRONTEND_URL}images/nvidia.png`} alt="nvidia" className="logonvidia" />
        <img src= {`${process.env.REACT_APP_FRONTEND_URL}images/adafruitLogo.jpg`}  alt="adafruit" className="logoadafruit" />
        <img src= {`${process.env.REACT_APP_FRONTEND_URL}images/sparkfunLogo.jpg`}  alt="sparkfun" className="logo" />
        <img src= {`${process.env.REACT_APP_FRONTEND_URL}images/microbitLogo.png`} alt="microbit" className="logo" />

      </div>

      </div>
  );
}
export default Head;
